<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import VueTagsInput from '@johmun/vue-tags-input'
import {
  authComputed,
  categoryComputed,
  categoryListMethod,
  meetingListMethod,
  batchListMethod,
  userListMethod,
  domainListMethod,
  courseListMethod,
  collegeListMethod,
  collegeComputed,
  departmentComputed,
  departmentListMethod,
} from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
    VueTagsInput,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      autocompleteItems: [
        {
          text: 'Artificial Intelligence',
        },
        {
          text: 'Python',
        },
        {
          text: 'Javascript',
        },
        {
          text: 'Big Data',
        },
        {
          text: 'HTML',
        },
      ],
      fields: [
        {
          key: 'title',
          label: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'category',
          label: 'Category',
          sortable: true,
          colType: 'default',
        },
        { key: 'action', title: 'Action', sortable: false, colType: 'button' },
      ],
      name: '',
      tag: '',
      tags: [],
      feature: '',
      features: [],
      topic: '',
      topics: [],
      careerOpportunity: '',
      careerProfile: '',
      careerProfiles: [],
      blogError: null,
      category: null,
      subcategory: null,
      blogDataStatus: false,
      isBlogError: false,
      isLoading: false,
      editorData: '',
      overview: '',
      // metaTitle: '',
      // metaDescription: '',
      categoryName: '',
      image: '',
      bgImage: '',
      show: false,
      siteconfiglist: [],
      platformId: [0],
      validTypeError: false,
      validSizeError: false,
      validTypeError1: false,
      validSizeError1: false,
      titleCharsLeft: '',
      platform: '',
      rating: '',
      careerSalary: '',
      meetingError: null,
      isMeetingError: false,
      meetingSuccess: '',
      isMeetingSuccess: false,
      classlist: [],
      collegeId: null,
      collegeClass: [],
      collegeClassPrev: [],
      departmentId: [],
      departmentlist: [],
      collegelist: [],
      categoryError: false,
      duration: '',
      AWSUrl: `${process.env.VUE_APP_AWS_URL}`,
    }
  },
  computed: {
    ...authComputed,
    ...categoryComputed,
    ...departmentComputed,
    ...collegeComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getTeachers()
    this.getListOfBatches()
    this.getDepartments()
    if (this.role !== 'admin') {
      this.platformId.push(this.profileData.platform_id)
    }
    if (this.role === 'administrator' || this.role === 'admin') {
      this.getColleges()
    } else {
      this.collegeId = this.profileData.college_id
    }
    if (this.role === 'teacher') {
      this.collegeClass.push(this.profileData.collegeClass)
    } else if (this.role === 'hod') {
      // this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
    this.getCategories()
  },
  methods: {
    ...batchListMethod,
    ...userListMethod,
    ...meetingListMethod,
    ...domainListMethod,
    ...courseListMethod,
    ...categoryListMethod,
    ...departmentListMethod,
    ...collegeListMethod,
    getCategories() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCategoryList({ filter })
        .then((categories) => {
          var listitems = []
          categories.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.categoryList = listitems
        })
        .catch((_error) => {})
    },
    getClasses() {
      this.collegeClass = []
      this.collegeClassPrev = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },
    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
    getColleges() {
      this.collegeId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          college.docs.forEach((element) => {
            let i = 0
            for (i = 0; i < this.platformId.length; i++) {
              if (element.platform_id === this.platformId[i]) {
                var ele = {}
                ele.text = element.name
                ele.value = element._id
                listitems.push(ele)
              }
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },
    updateCourseData() {
      this.timeError = false
      this.isLoading = true
      if (
        this.category !== this.data.category_id &&
        (this.subcategory === this.data.subcategory_id &&
          this.data.subcategory_id !== null)
      ) {
        this.categoryError = true
        this.isLoading = false
      } else {
        this.categoryError = false
      }
      if (!this.categoryError) {
        this.isLoading = true
        const Data = {
          id: this.data._id,
          name: this.name,
          description: this.editorData,
          overview: this.overview,
          category_id: this.category,
          subcategory_id: this.subcategory,
          career_salary: this.careerSalary,
          career_opportunity: this.careerOpportunity,
          career_profiles: this.filterTag(this.careerProfiles),
          features: this.filterTag(this.features),
          topics: this.filterTag(this.topics),
          category: this.categoryName,
          status: false,
          rating: this.rating,
          collegeClass: [this.collegeClass, this.collegeClassPrev],
          department: this.departmentId,
          college_id: this.collegeId,
          duration: this.duration,
        }
        if (this.image !== this.data.image) {
          if (
            localStorage.getItem('width') === '500' &&
            localStorage.getItem('height') === '500'
          ) {
            this.validSizeError = false
            Data['image'] = this.image
          } else {
            this.isLoading = false
            this.validSizeError = true
          }
        }
        if (this.bgImage !== this.data.bg_image) {
          if (
            localStorage.getItem('widthBg') === '1000' &&
            localStorage.getItem('heightBg') === '500'
          ) {
            this.validSizeError1 = false
            Data['bg_image'] = this.bgImage
          } else {
            this.isLoading = false
            this.validSizeError1 = true
          }
        }
        if (
          !this.validTypeError &&
          !this.validTypeError1 &&
          !this.validSizeError &&
          !this.validSizeError1
        ) {
          this.updateCourse({ Data })
            .then((blog) => {
              this.isLoading = false
              this.$bvToast.toast('Course Updated Successfully', {
                title: `Success`,
                toaster: 'b-toaster-top-right',
                solid: true,
                variant: 'success',
                appendToast: false,
              })
              window.location.reload()
            })
            .catch((error) => {
              this.isLoading = false
              var getError = new ErrorWrapper(error)
              this.meetingError = getError.message
              this.isMeetingError = true
            })
        }
      }
    },

    getData() {
      this.image = this.data.image
      this.bgImage = this.data.bg_image
      this.name = this.data.name
      this.editorData = this.data.description
      this.metaTitle = this.data.meta_title
      this.metaDescription = this.data.meta_description
      this.overview = this.data.overview
      this.category = this.data.category_id
      this.selectCategory()
      this.subcategory = this.data.subcategory_id
      this.careerSalary = this.data.career_salary
      this.careerOpportunity = this.data.career_opportunity
      this.status = this.data.status
      this.rating = this.data.rating
      this.platform = this.data.platform
      this.duration = parseInt(this.data.duration)
      let i = 0
      for (let i = 0; i < this.data.features.length; i++) {
        this.features.push({ text: this.data.features[i] })
      }
      for (let i = 0; i < this.data.topics.length; i++) {
        this.topics.push({ text: this.data.topics[i] })
      }
      for (let i = 0; i < this.data.career_profiles.length; i++) {
        this.careerProfiles.push({ text: this.data.career_profiles[i] })
      }
      for (let i = 0; i < this.data.platform_id.length; i++) {
        this.platformId.push(this.data.platform_id[i])
      }
      if (this.role === 'administrator' || this.role === 'admin') {
        this.collegeId = this.data.college_id
        this.getDepartments()
      }
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
        this.getClasses()
      }
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
        this.collegeClassPrev.push(this.data.collegeClass[i])
      }
    },
    selectCategory() {
      this.show = true
      // this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },
    // trigger when select image in input
    uploadImage: function() {
      var file = document.getElementById('file').files[0]
      let mimeType = document.getElementById('file').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          this.image = reader.result
        }
      } else {
        this.validTypeError = true
      }
    },

    uploadBgImage: function() {
      var file = document.getElementById('file1').files[0]
      let mimeType = document.getElementById('file1').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError1 = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('widthBg', img.width)
            localStorage.setItem('heightBg', img.height)
          }
          img.src = evt.target.result
          this.bgImage = reader.result
        }
      } else {
        this.validTypeError1 = true
      }
    },

    // filter tag
    filterTag(tags) {
      var finalTags = []
      tags.forEach((element) => {
        finalTags.push(element.text)
      })

      return finalTags
    },
    getCount() {
      this.titleCharsLeft = 100 - this.title.length
      if (this.title.length >= 100) {
        this.titleCharsLeft = 0
      }
    },

    resetModal() {
      this.timeError = false
      this.isMeetingError = false
      this.departmentId = []
      this.collegeId = ''
      this.collegeClass = []
      this.careerProfiles = []
      this.features = []
      this.topics = []
      this.categoryError = false
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars2(event) {
      if (event.charCode === 32 && !this.duration.length) {
        event.preventDefault()
      } else {
        if (event.charCode >= 48 && event.charCode <= 57) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },
    getListOfBatches() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        order: '1',
      }
      this.fetchBatchList({ filter })
        .then((batches) => {
          var listitems = []
          batches.docs.forEach((element) => {
            var ele = {}

            ele.text = element.name
            ele.value = element._id
            listitems.push(ele)
            this.batchList = listitems
          })
        })
        .catch((_error) => {})
    },
    getTeachers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'first_name',
        order: '1',
      }
      this.fetchTeacherList({ filter })
        .then((teachers) => {
          var listitems = []
          teachers.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = element._id
            listitems.push(ele)
            this.teacherList = listitems
          })
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="course-edit-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isMeetingSuccess"
          variant="success"
          v-html="meetingSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateCourseData">
          <b-form-group label="Name*(Max:100 characters)" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              parsley-trigger="change"
              required
              placeholder="Enter Name"
              :maxlength="100"
              @keyup="getCount"
              @keypress="restrictChars($event)"
            ></b-form-input>
            <p v-if="titleCharsLeft !== ''"
              >Characters left : {{ titleCharsLeft }}</p
            >
          </b-form-group>

          <b-form-group label="Category*" label-for="input-2">
            <b-form-select
              v-model="category"
              parsley-trigger="change"
              required
              @change="selectCategory"
            >
              <b-select-option :value="null" disabled
                >Select Category</b-select-option
              >
              <b-select-option
                v-for="cate in categoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Sub category" label-for="input-2">
            <b-form-select v-model="subcategory" parsley-trigger="change">
              <b-select-option :value="null" disabled
                >Select SubCategory</b-select-option
              >
              <b-select-option
                v-for="cate in subCategoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <p v-if="categoryError" style="color:red;"
            >Please select subcategory</p
          >
          <b-form-group label="Career Opportunity*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="careerOpportunity"
              type="text"
              parsley-trigger="change"
              required
              placeholder="Enter Career Opportunity"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Career Profiles*" label-for="input-2">
            <VueTagsInput
              v-model="careerProfile"
              input-id="tags-separators"
              placeholder="Enter Career profile(s) and Press Enter.."
              :tags="careerProfiles"
              :autocomplete-items="filteredItems"
              @tags-changed="(newTags) => (careerProfiles = newTags)"
            />
          </b-form-group>

          <b-form-group label="Career Salary*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="careerSalary"
              type="number"
              parsley-trigger="change"
              required
              placeholder="Enter career salary"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Features*" label-for="input-2">
            <VueTagsInput
              v-model="feature"
              input-id="tags-separators"
              placeholder="Enter Feature(s) and Press Enter.."
              :tags="features"
              :autocomplete-items="filteredItems"
              @tags-changed="(newTags) => (features = newTags)"
            />
          </b-form-group>
          <b-form-group label="Topics*" label-for="input-2">
            <VueTagsInput
              v-model="topic"
              input-id="tags-separators"
              placeholder="Enter Topic(s) and Press Enter.."
              :tags="topics"
              :autocomplete-items="filteredItems"
              @tags-changed="(newTags) => (topics = newTags)"
            />
          </b-form-group>

          <b-form-group label="Overview*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="overview"
              type="text"
              parsley-trigger="change"
              required
              placeholder="Enter Overview"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Duration*(in hours)" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="duration"
              type="text"
              parsley-trigger="change"
              required
              placeholder="Enter Duration"
              @keypress="restrictChars2($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Rating*(Max:5)" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="rating"
              type="number"
              parsley-trigger="change"
              required
              placeholder="Enter Rating"
              :max="5"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Description*" label-for="input-2">
            <quill-editor v-model="editorData" output="html" />
          </b-form-group>
          <div v-if="image">
            <b style="color:#323a46;">Uploaded Image:</b><br /><br />
            <img
              :src="AWSUrl + image"
              style="width:150px;height:100px;margin:auto;"
              alt="course-image"
            />
            <br />
          </div>
          <b-form-group label="Image" label-for="input-2">
            <b-form-file
              id="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="uploadImage"
            ></b-form-file>
            <p v-if="validTypeError" class="showError">Not a valid file type</p>
            <p v-if="validSizeError" class="showError"
              >Image Dimensions should be 500*500</p
            >
          </b-form-group>
          <div v-if="bgImage">
            <b style="color:#323a46;">Uploaded Background Image:</b><br /><br />
            <img
              :src="AWSUrl + bgImage"
              style="width:150px;height:100px;margin:auto;"
              alt="course-image"
            />
            <br /><br />
          </div>
          <b-form-group label="Course Background Image" label-for="input-2">
            <b-form-file
              id="file1"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="uploadBgImage"
            ></b-form-file>
            <p v-if="validTypeError1" class="showError"
              >Not a valid file type</p
            >
            <p v-if="validSizeError1" class="showError"
              >Image Dimensions should be 1000*500</p
            >
          </b-form-group>
          <b-form-group
            v-if="role === 'administrator' || role === 'admin'"
            label="Select College*"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeId"
              :options="collegelist"
              @change="getDepartments"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <br />
          <b-alert
            v-model="isMeetingError"
            variant="danger"
            v-html="meetingError"
          ></b-alert>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}

.showError {
  color: red;
}
</style>
